var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46582 3.25C9.05626 3.25 9.59261 3.47603 9.99805 3.84375C10.4037 3.47485 10.9426 3.25 11.5342 3.25H14.625C15.5915 3.25 16.375 4.0335 16.375 5V6.27832C17.7162 6.46139 18.75 7.60856 18.75 9V14C18.75 15.5188 17.5188 16.75 16 16.75H4C2.48122 16.75 1.25 15.5188 1.25 14V9C1.25 7.60856 2.28381 6.46139 3.625 6.27832V5C3.625 4.0335 4.4085 3.25 5.375 3.25H8.46582ZM16.375 12.2041C16.375 13.1706 15.5915 13.9541 14.625 13.9541H12.0459C11.3789 13.9541 10.8283 14.4593 10.7578 15.1074L10.751 15.25H16C16.6904 15.25 17.25 14.6904 17.25 14V9C17.25 8.44034 16.8821 7.96693 16.375 7.80762V12.2041ZM3.625 7.80762C3.11792 7.96693 2.75 8.44034 2.75 9V14C2.75 14.6904 3.30964 15.25 4 15.25H9.25C9.25 14.5345 8.66956 13.9541 7.9541 13.9541H5.375C4.4085 13.9541 3.625 13.1706 3.625 12.2041V7.80762ZM5.375 4.75C5.23693 4.75 5.125 4.86193 5.125 5V12.2041C5.125 12.3422 5.23693 12.4541 5.375 12.4541H7.9541C8.42283 12.4541 8.86254 12.5728 9.25 12.7773V5.53418C9.25 5.10114 8.89886 4.75 8.46582 4.75H5.375ZM11.5342 4.75C11.1308 4.75 10.798 5.05508 10.7549 5.44629L10.75 5.5498V12.7754C11.1377 12.5719 11.5776 12.4541 12.0459 12.4541H14.625L14.6758 12.4492C14.7895 12.4258 14.875 12.3248 14.875 12.2041V5C14.875 4.86193 14.7631 4.75 14.625 4.75H11.5342Z",
    fill: "#101820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/onboarding.06e2b4697e0425f895f368442e914d86.svg";
export { ForwardRef as ReactComponent };